import { Dispatch, SetStateAction } from "react";

import { AutoComplete, Form, FormInstance } from "antd";

import phoneIconGray from "data/icons/phone-gray.svg";
import emailIconGray from "data/icons/email-gray.svg";

interface IProps {
  author: string;
  setAuthor: (value: string) => void;
  form: FormInstance;
  debouncedClients: any;
  clients: any[];
  setIsAuthorEmailExist: Dispatch<SetStateAction<boolean>>;
}

const CaseContactNameField = ({
  author,
  setAuthor,
  form,
  debouncedClients,
  clients,
  setIsAuthorEmailExist,
}: IProps) => {
  return (
    <Form.Item
      label="Contact Name"
      name="author_name"
      valuePropName="label21"
      rules={ [ { required: true, message: "Please input name!" } ] }
      style={ { marginBottom: 15 } }
    >
      <AutoComplete
        allowClear
        autoClearSearchValue
        showSearch
        value={ author }
        onChange={ (value, option) => {
          // @ts-ignore
          setAuthor(option?.name || value);

          if (option) {
            setIsAuthorEmailExist(true);
          }

          // @ts-ignore
          if (value && option?.id) {
            form.setFieldsValue({
              // @ts-ignore
              author_email: option?.email || "",
              // @ts-ignore
              author_phone_number: option?.phone_number || "",
              // @ts-ignore
              author_name: option?.name || "",
            });

            debouncedClients.cancel();
          }
        } }
        onSearch={ (value) => debouncedClients(value) }
        filterOption={ false }
        placeholder="Name"
        options={ clients.map(client => ({
          id: client.id,
          key: client.id,
          value: client.id,
          name: `${ client.label }${ client.lastName ? ` ${ client.lastName }` : "" }`,
          phone_number: client.phone_number,
          email: client.email,
          label2: `${ client.label } ${ client.lastName || "" }`,
          label: (
            <div>
              <div style={ { color: "#0C758C" } }>
                { client.label } { client.lastName }
              </div>
              <div
                style={ {
                  fontSize: "12px",
                  lineHeight: "14px",
                  marginBottom: "2px",
                  color: "#769197",
                } }
              >
                <img
                  alt=""
                  style={ { marginBottom: "-1px" } }
                  src={ phoneIconGray }
                /> { client.phone_number }
              </div>

              <div
                style={ {
                  fontSize: "12px",
                  lineHeight: "14px",
                  marginBottom: "2px",
                  color: "#769197",
                } }
              >
                <img
                  alt=""
                  style={ { marginBottom: "-1px" } }
                  src={ emailIconGray }
                /> { client.email }
              </div>
            </div>
          ),
        })) }
        notFoundContent={ null }
        dropdownStyle={ { visibility: "visible" } }
      />
    </Form.Item>
  );
};

export default CaseContactNameField;
